import Vue from 'vue'
import Alert from './Alert.vue'
import Confirm from './Confirm.vue'

let AlertConstructor, alertDom, ConfirmConstructor, confirmDom
try {
  // 返回一个 扩展实例构造器
  AlertConstructor = Vue.extend(Alert)
  // 实例化
  alertDom = new AlertConstructor({
    el: document.createElement('div'),
  })

  // 把 实例化的 Loading.vue 添加到 body 里
  document.body.appendChild(alertDom.$el)

  ConfirmConstructor = Vue.extend(Confirm)
  // 实例化
  confirmDom = new ConfirmConstructor({
    el: document.createElement('div'),
  })

  // 把 实例化的 Loading.vue 添加到 body 里
  document.body.appendChild(confirmDom.$el)
} catch(e) {
  window.console.error(e)
}


// 注册为全局组件的函数
function registryAlert() {
  // 将组件注册到 vue 的 原型链里去,
  // 这样就可以在所有 vue 的实例里面使用 this.$loading.show()
  Vue.prototype.$alert = {
    show(text, option) {
        alertDom.text = text
        if (option) {
          if (option.title && option.title.length > 0) {
            alertDom.title = option.title
          } else {
            alertDom.title = '温馨提示'
          }
          if (option.confirmCallBack) {
            alertDom.confirmCallBack = option.confirmCallBack
          } else {
            alertDom.confirmCallBack = null
          }
          if (option.button && option.button.length > 0) {
            alertDom.button = option.button
          } else {
            alertDom.button = '确定'
          }
        }
        else {
          alertDom.title = '温馨提示'
          alertDom.confirmCallBack = null
          alertDom.button = '确定'
        }
        alertDom.isShow = true
    }
  },
  Vue.prototype.$confirm = {
      show(text, option) {
        confirmDom.text = text
        const buttons = ['取消', '确定']
        if (option) {
          if (option.title && option.title.length > 0) {
            confirmDom.title = option.title
          } else {
            confirmDom.title = '温馨提示'
          }
          if (option.confirmCallBack) {
            confirmDom.confirmCallBack = option.confirmCallBack
          } else {
            confirmDom.confirmCallBack = null
          }
          if (option.cancelCallBack) {
            confirmDom.cancelCallBack = option.cancelCallBack
          } else {
            confirmDom.cancelCallBack = null
          }
          if (option.confirmBtn && option.confirmBtn.length > 0) {
            buttons[1] = option.confirmBtn
          } 
          if (option.cancelBtn && option.cancelBtn.length > 0) {
            buttons[0] = option.cancelBtn
          } 
        } else {
          confirmDom.title = '温馨提示'
          confirmDom.confirmCallBack = null
          confirmDom.cancelCallBack = null
        }
        confirmDom.buttons = buttons
        confirmDom.isShow = true
      }
  }
}

export default registryAlert